import React from "react";
import moment from "moment";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setRedirectPath} from "../../modules/actions/authActions";
import {addToCart, getCart} from "../../modules/actions/cartActions";
import {addFlashMessage} from "../../modules/actions/flashMessages.js";
import "react-datepicker/dist/react-datepicker.css";
import {Link, withRouter} from "react-router-dom";
import qs from "qs";
import {format} from "../../modules/utils";
import { addActiveSimRequest, validateSimBySimCard } from "../../modules/actions/productActions";
//import InputMask from 'react-input-mask';
import MaskedInput from 'react-text-mask'
import NotificationAlert from "react-notification-alert";

class ActiveSimRequestController extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            purchasedStore: "Amazon",
            orderId: "",
            inputMask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
            validateSimError : false,
            simCardError : false,
            orderIdError: false,
            updatedAt : moment().format("MM/DD/YYYY"),
            createdAt : moment().format("MM/DD/YYYY"),
            requestSubmitted : false
        };
    }


    static getSeller(){
        return [{
            id : 1,
            name : "Amazon"
        },{
            id : 2,
            name : "MightyWifi"
        }]
    }

    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };


    _onChange = event => {
        const field = event.target.name;
        const value = event.target.value;

        console.log("field " + field + " , value " + value  );

        this.setState({ [field]: value });

        if(field == 'purchasedStore') {
            if(value == 'Amazon') {
                this.state.inputMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
                this.state.orderId = "";
            }
            else {
                this.state.inputMask = "";
                this.state.orderId = "";
            }
        }
    };

    validateForm(){
        let simCardError = false;
        let orderIdError = false;
        if (typeof this.state.simCard === "undefined" || this.state.simCard == ""){
            simCardError = true;
        }


        if (typeof this.state.orderId === "undefined" || this.state.orderId == ""){
            orderIdError = true;
        }

        this.setState({
            simCardError : simCardError,
            orderIdError : orderIdError,
        });


        return !(simCardError === true || orderIdError === true);

    }

    saveActiveSimRequest = () => {

        if (this.validateForm()){
            let user = null;
            if(this.props.auth.isAuthenticated === true){
                user = this.props.auth.user.user;
            }

            let { orderId, purchasedStore, simCard, updatedAt, createdAt } = this.state;
            let payload = {
                orderId : orderId,
                purchasedStore : purchasedStore,
                simCard : simCard,
                user : user,
                createdAt : createdAt,
                updatedAt : updatedAt
            };


            this.props.validateSimBySimCard({
                simCard : simCard
            }).then(
                res => {
                    if (res.status && typeof res.sim !== "undefined" && typeof res.sim._id !== "undefined"){
                        this.props.addActiveSimRequest(payload).then(
                            res => {
                                if (res.status){
                                    this.setState({
                                        requestSubmitted : true
                                    })
                                    console.log("Request submitted Successfully")
                                }
                                else {
                                    this.showMessage(res.message);
                                }
                            },
                            err => {
                                console.log("Request has error : ", err.response.data.message)
                            }
                        )
                    }else{
                        this.setState({
                            validateSimError : true
                        })
                    }
                },
                err => {
                    this.setState({
                        validateSimError : true
                    })
                }
            );
        }
    };


    render() {
        return(
            <section className="BodyContainer">
                <div className="container">
                    <div className="row position-relative">
                        <NotificationAlert ref="notify"/>

                        <div className="col-lg-4 services_img_bg">
                            <img src="/images/121918-001.jpg"/>
                        </div>

                        <div className="col-lg-8 sim_services_clip">
                            <div className="services_bg_pad">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="text-left services_boxes mt-3 rounded p-4">

                                            <div className="services_content mt-3">
                                                <h5 className="SansSerif">T-Mobile Prepaid SIM Card Unlimited Talk, Text, and Data.</h5>
                                                <h3 className="m-Title SansSerif bold700">Activate</h3>

                                                <div style={{ clear: "both", height: "20px" }} />

                                                {
                                                    (this.state.requestSubmitted) ? (
                                                        <div>
                                                            <h2>Congratulations!</h2>
                                                            <p className="margin-top-35">
                                                                Your sim card activation is now complete.<br/>
                                                                Please allow up to 24 hours for the activation process,<br/>
                                                                and then you may begin using the service right away.
                                                            </p>

                                                            <Link className="btn btn-outline-white margin-top-35" style={{margin:'30px auto'}} to={{
                                                                pathname: "/dashboard"
                                                            }}>
                                                                My Account
                                                            </Link>
                                                            {/*<a href="javascript:void(0)" className="" onClick={this.saveActiveSimRequest}>Continue</a>*/}
                                                            <p className="mb-0 mt-6">
                                                                <h1 style={{marginTop:'40px'}}>&nbsp;</h1>
                                                            </p>
                                                        </div>


                                                    ) : null
                                                }

                                                {(!this.state.requestSubmitted) ? (
                                                    <div>
                                                        <div className="center-position">
                                                            <div className="form-group text-left">
                                                                <strong>Sim Number</strong>
                                                            </div>
                                                            <div className="form-group text-left">
                                                                <input id="sim-cart" className="form-control no-border-radius sim-card-field" name="simCard" type="text" onChange={this._onChange} required/>
                                                                { (this.state.simCardError) ? (
                                                                    <span className="error text-danger">Sim Number Required</span>
                                                                ) : null}

                                                                { (this.state.validateSimError === true) ? (
                                                                    <span className="error text-danger">Sim Card not verified.</span>
                                                                ) : null}
                                                            </div>
                                                        </div>

                                                        <div style={{ clear: "both", height: "20px" }} />

                                                        <div className="center-position">
                                                            <div className="form-group text-left">
                                                                <strong>Purchased From</strong>
                                                            </div>
                                                            <div className="form-group text-left">
                                                                <select name="purchasedStore" className="form-control" id="seller" onChange={this._onChange}>
                                                                    {
                                                                        ActiveSimRequestController.getSeller().map(
                                                                            (seller) => (
                                                                                <option value={seller.name}>{seller.name}</option>
                                                                            )
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div style={{ clear: "both", height: "20px" }} />

                                                        <div className="center-position">
                                                            <div className="form-group text-left">
                                                                <strong>Seller Order ID</strong>
                                                            </div>
                                                            <div className="form-group text-left">
                                                                {/*<input id="order-id" className="form-control no-border-radius order-id-field max-width-300-px" name="orderId" type="text" onChange={this._onChange} required/>*/}
                                                                {/*<InputMask mask={this.state.inputMask} value={this.state.orderId} alwaysShowMask="true" id="order-id" className="form-control no-border-radius order-id-field" name="orderId" type="text" onChange={this._onChange} required />*/}
                                                                <MaskedInput mask={this.state.inputMask} value={this.state.orderId} id="order-id" className="form-control no-border-radius order-id-field" name="orderId" type="text" onChange={this._onChange} required />
                                                                { (this.state.orderIdError) ? (
                                                                    <span className="error text-danger">Seller Order ID Required</span>
                                                                ) : null}
                                                            </div>
                                                        </div>

                                                        <a href="javascript:void(0)" className="btn btn-white margin-top-35" onClick={this.saveActiveSimRequest}>Continue</a>

                                                    </div>
                                                ) : null}

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


ActiveSimRequestController.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
    };
}

export default withRouter(connect(
    mapStateToProps,
    { addActiveSimRequest, validateSimBySimCard }
)(ActiveSimRequestController));



// WEBPACK FOOTER //
// ./src/pages/ActiveSim/ActiveSimRequestController.js